import { isRequired, getArray } from '../../utils.js';

var abTest = (_ref => {
  let {
    experiment_id = isRequired('experiment_id')
  } = _ref;
  return {
    experiment_id: getArray(experiment_id)
  };
});

export default abTest;
